var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { isEmpty } from 'lodash-es';
import { LogAction, } from './type';
export function getColorByLogLevel(type) {
    if (type === 'success') {
        return '#00CC00';
    }
    else if (type === 'warning') {
        return '#CC9900';
    }
    else if (type === 'error') {
        return '#CC3333';
    }
    else {
        return '#0099CC';
    }
    // else if (type === 'debug') {
    //   return '#663399';
    // }
}
// TODO: 代码可读性优化，参考类似 https://www.npmjs.com/package/styled-log
function doConsole(_a, ...restArgs) {
    var { namespace, scope, level, message, eventName } = _a, rest = __rest(_a, ["namespace", "scope", "level", "message", "eventName"]);
    const logs = [
        `%c Logger %c ${namespace ? namespace : level}${scope ? ` %c ${scope}` : ''} %c`,
        `background:#444444 ; padding: 1px; border-radius: 3px 0 0 3px; color: #fff`,
        `background:${getColorByLogLevel(level)}; padding: 1px; border-radius: ${scope ? '0' : '0 3px 3px 0'}; color: #fff`,
        scope
            ? `background:#777777; padding: 1px; border-radius: 0 3px 3px 0; color: #fff; margin-left: -1px;`
            : 'background:transparent',
    ];
    if (scope) {
        logs.push('background:transparent');
    }
    logs.push(eventName || message);
    const payload = rest.error ? rest : rest.meta;
    if (!isEmpty(payload)) {
        logs.push(payload);
    }
    logs.push(...restArgs);
    // eslint-disable-next-line no-console
    console.log(...logs);
}
export class ConsoleLogClient {
    send(_a) {
        var { meta, message, eventName, action } = _a, rest = __rest(_a, ["meta", "message", "eventName", "action"]);
        // eslint-disable-next-line no-nested-ternary
        const resolvedMsg = message
            ? message
            : eventName
                ? `Event: ${eventName}`
                : undefined;
        // console.log('======', action, resolvedMsg);
        if (!(action === null || action === void 0 ? void 0 : action.includes(LogAction.CONSOLE)) || !resolvedMsg) {
            return;
        }
        const payload = Object.assign(Object.assign({}, rest), { message: resolvedMsg });
        if (meta) {
            doConsole(payload, meta);
        }
        else {
            doConsole(payload);
        }
    }
}
export const consoleLogClient = new ConsoleLogClient();
